import type { ReactNode } from 'react';

/** Shared input styling for the Create User form (matches the design + project tokens). */
export const FIELD =
  'w-full rounded-lg border bg-white px-[15px] py-2.5 text-sm text-ink placeholder:text-[#94a3b8] transition-colors focus:outline-none focus:ring-2';
export const fieldCls = (invalid?: string) =>
  [
    FIELD,
    invalid
      ? 'border-red-400 focus:border-red-500 focus:ring-red-100'
      : 'border-[#e2e8f0] focus:border-brand focus:ring-brand/15',
  ].join(' ');

/** A labelled form field with optional required marker, right-aligned action + error. */
export function Field({
  label,
  htmlFor,
  error,
  required,
  action,
  children,
}: {
  label: string;
  htmlFor?: string;
  error?: string;
  required?: boolean;
  /** Optional control shown on the right of the label row (e.g. "+ Add another…"). */
  action?: ReactNode;
  children: ReactNode;
}) {
  return (
    <div className="flex min-w-0 flex-1 flex-col gap-1.5">
      <div className="flex items-center justify-between gap-2">
        <label htmlFor={htmlFor} className="text-xs font-medium leading-4 text-[#475569]">
          {label}
          {required && <span className="text-[#ef4444]"> *</span>}
        </label>
        {action}
      </div>
      {children}
      {error && <span className="text-xs font-medium text-[#ba1a1a]">{error}</span>}
    </div>
  );
}

/** Small uppercase section heading (Figma: 11px bold, tracked, slate-400). */
export function SectionHeading({ children, action }: { children: ReactNode; action?: ReactNode }) {
  return (
    <div className="flex items-center justify-between">
      <h3 className="text-[11px] font-bold uppercase tracking-[0.55px] text-[#94a3b8]">{children}</h3>
      {action}
    </div>
  );
}
